module.exports = __webpack_public_path__ + "static/img/banner_02.737de5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_02.jpg
// module id = iWXU
// module chunks = 2